import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import LedLighting from './components/LedLighting';
import Subscriptions from './components/Subscriptions';
import Contact from './components/Contact';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="bg-gradient-to-b from-[#0A0A0A] to-[#1A1A1A] min-h-screen">
      {/* Navegación Fija */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0A0A0A]/95 backdrop-blur-lg shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 md:gap-3">
            <div className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center">
              <i className="ri-flashlight-line text-[#FFD700] text-xl md:text-2xl"></i>
            </div>
            <span className="text-white font-bold text-sm md:text-xl" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Electricidad y Tecnología
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-6">
            <button onClick={() => scrollToSection('inicio')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">Inicio</button>
            <button onClick={() => scrollToSection('nosotros')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">Nosotros</button>
            <button onClick={() => scrollToSection('servicios')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">Servicios</button>
            <button onClick={() => scrollToSection('iluminacion')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">Iluminación LED</button>
            <button onClick={() => scrollToSection('suscripciones')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">Suscripciones</button>
            <button onClick={() => scrollToSection('contacto')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">Contacto</button>
            <a
              href="https://wa.me/34633518361"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#FFD700] text-black px-6 py-2.5 rounded-full font-semibold hover:bg-[#FFC700] hover:shadow-lg hover:shadow-[#FFD700]/50 transition-all duration-300 hover:scale-105 text-sm whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Urgencias 24/7
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-white text-2xl cursor-pointer z-50"
            aria-label="Toggle menu"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu Drawer */}
        <div className={`lg:hidden fixed inset-0 bg-[#0A0A0A]/98 backdrop-blur-lg transition-transform duration-300 ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{ top: '72px' }}>
          <div className="flex flex-col items-center justify-center h-full gap-6 px-8">
            <button onClick={() => scrollToSection('inicio')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-lg font-medium cursor-pointer">Inicio</button>
            <button onClick={() => scrollToSection('nosotros')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-lg font-medium cursor-pointer">Nosotros</button>
            <button onClick={() => scrollToSection('servicios')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-lg font-medium cursor-pointer">Servicios</button>
            <button onClick={() => scrollToSection('iluminacion')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-lg font-medium cursor-pointer">Iluminación LED</button>
            <button onClick={() => scrollToSection('suscripciones')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-lg font-medium cursor-pointer">Suscripciones</button>
            <button onClick={() => scrollToSection('contacto')} className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 text-lg font-medium cursor-pointer">Contacto</button>
            <a
              href="https://wa.me/34633518361"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#FFD700] text-black px-8 py-3 rounded-full font-semibold hover:bg-[#FFC700] transition-all duration-300 text-base cursor-pointer mt-4"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Urgencias 24/7
            </a>
          </div>
        </div>
      </nav>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/34633518361"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 md:bottom-6 right-4 md:right-6 z-50 w-12 h-12 md:w-16 md:h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 group"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-2xl md:text-3xl group-hover:scale-110 transition-transform"></i>
      </a>

      {/* Secciones */}
      <div id="inicio">
        <Hero />
      </div>
      <div id="nosotros">
        <AboutUs />
      </div>
      <div id="servicios">
        <Services />
      </div>
      <div id="iluminacion">
        <LedLighting />
      </div>
      <div id="suscripciones">
        <Subscriptions />
      </div>
      <div id="contacto">
        <Contact />
      </div>
    </div>
  );
}